import * as yup from "yup";
import i18next from "config/i18next";
import { VALIDATION_REGEX } from "utils/constants";
import { AnyObject } from "final-form";
import { FilterContainerValidationSchemaTypes } from "./types";

const validateIdentificationNumber = (
  value: string | undefined,
  context: yup.TestContext<AnyObject>
) => {
  const { createError } = context;
  const parent = context.parent as FilterContainerValidationSchemaTypes;
  const field = "identificationNumber";
  let errorMessage;

  if (!value) return true;

  if (!parent.identificationType?.tag) {
    if (value && value.length < 6) {
      errorMessage = "filterPickers:identificationNumberLength";
    } else if (!value?.match(VALIDATION_REGEX.identificationNumber)) {
      errorMessage = "validations:specialCharacters";
    }
  } else if (!value?.match(VALIDATION_REGEX.identificationNumberCC)) {
    errorMessage = "filterPickers:identificationNumberFormatCC";
  }
  if (errorMessage) {
    return createError({
      message: i18next.t(errorMessage),
      path: field,
    });
  }
  return true;
};

export const identificationNumber = yup
  .string()
  .test("identificationValidation", (value, context) =>
    validateIdentificationNumber(value, context)
  );

export const validationSchemaCO = yup.object({
  name: yup
    .string()
    .matches(
      VALIDATION_REGEX.expName,
      i18next.t("validations:numbersOrSpecialCharacters")
    ),
  identificationType: yup.object(),
  identificationNumber,
  email: yup
    .string()
    .matches(
      VALIDATION_REGEX.regEmail,
      i18next.t("validations:invalidEmailFormat")
    ),
});
